import _ from 'lodash'
import { v4 as uuidv4 } from 'uuid'
import qs from 'qs'

import { defaultInstance } from 'services'

import { removeEmpty } from 'utils'
import { responseSuccess, responseError } from 'utils/response'

export const mapFieldReportAttribute = (item, index) => {
  return {
    ...item,
    index,
    key: uuidv4(),
  }
}

export const getReportTypeAttributeListApi = ({
  report_type_id,
  group_attribute_id,
  data_type_id,
  key_attribute,
  param,
  is_active,
  page,
  size,
}) => {
  const params = removeEmpty({
    group_attribute_id,
    data_type_id,
    key_attribute,
    param,
    is_active,
    page,
    size,
  })

  const config = {
    method: 'get',
    url: `/api/v1/report_attribute/${report_type_id}`,
    params,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data?.items) {
        return responseSuccess({
          data: {
            items: _.map(res.data?.items, mapFieldReportAttribute),
            total: res.data.total,
            page: res.data.page,
            size: res.data.size,
          },
        })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const createReportTypeAttributeApi = (data) => {
  const config = {
    method: 'post',
    url: '/api/v1/report_attribute/',
    data,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const getReportTypeAttributeByIdApi = (id) => {
  const config = {
    method: 'get',
    url: `/api/v1/report_attribute/${id}`,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: mapFieldReportAttribute(res.data?.[0]) })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const deleteReportTypeAttributeByIdApi = (id) => {
  const config = {
    method: 'delete',
    url: `/api/v1/report_attribute/${id}`,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}

export const updateReportTypeAttributeByIdApi = (id, data) => {
  const config = {
    method: 'patch',
    url: `/api/v1/report_attribute/${id}`,
    data,
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({ data: res.data })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}


export const getReportTypeAttributeReportTypeListApi = ({
  report_type_id
}) => {
  const params = removeEmpty({
    report_type_id: report_type_id
  })

  const config = {
    method: 'get',
    url: `/api/v1/report_attribute_report_type`,
    params,
    paramsSerializer: (params) => {
      return qs.stringify(params, { arrayFormat: 'repeat' })
    },
  }

  return defaultInstance
    .request(config)
    .then((res) => {
      if (res.data) {
        return responseSuccess({
          data: {
            items: _.map(res.data, mapFieldReportAttribute)
          },
        })
      }
      return responseError({ message: 'API something went wrong' })
    })
    .catch((err) => {
      if (err.response) {
        return responseError({
          message: String(err.response.data?.detail || err.response.data?.message),
        })
      } else if (err.request) {
        return responseError({ message: err.message })
      }
      return responseError({ message: err.message })
    })
}
